<template>
  <Root></Root>
</template>

<script setup lang="ts">
import Root from "./components/base/Root.vue";

// 所有 router 中定义的可访问的有style的页面
import Lot from "./components/xg/Lot.vue";
import Park from "./components/xg/Park.vue";
import Result from "./components/xg/Result.vue";
import Unlocking from "./components/xg/Unlocking.vue";
import LoginInPhone from "./components/xg/LoginInPhone.vue";
import ViewDocument from "./components/view/ViewDocument.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { Lot, Park, Result, Unlocking, LoginInPhone, ViewDocument },
  inheritAttrs: true
});

defineExpose({});
</script>
